module.exports = __webpack_public_path__ + "static/media/preg_cancer_pt.1746dac8.webp";